module.exports = __webpack_public_path__ + "img/gallery-frame02.97c5f9a8.png";